import type { ReactNode } from "react";
import type { FieldError, Merge } from "react-hook-form";
import { cn } from "../lib/utils";
import { FormFieldError } from "./FormFieldError";

type FormFieldGroupProps = {
	condensed?: boolean;
	className?: string;
	children: ReactNode;
	error?: FieldError | Merge<FieldError, (FieldError | undefined)[]>;
	errorMessage?: string;
};

export const FormFieldGroup = (props: FormFieldGroupProps) => (
	<div
		className={cn(
			"w-full flex flex-col h-fit space-y-[20px] shrink-0",
			props.condensed ? "space-y-[16px]" : undefined,
			props.className,
			props.error ? "outline outline-red-500 outline-offset-[8px] rounded-md" : undefined,
		)}
	>
		{props.children}
		<FormFieldError
			error={props.error}
			errorMessage={props.errorMessage ?? props.error?.message}
			className={cn("top-[-34px]")}
		/>
	</div>
);
